import React,
{
  useEffect,
  useState
} from "react";

import axios from "axios";
import { useParams }
from "react-router-dom";

const BASE_API =
  process.env.BASE_API_URL ||
  "https://scanmymenu-nm38.onrender.com/api";

export default function EditRestaurant() {

  const { id } =
    useParams();

  const [
    restaurantName,
    setRestaurantName
  ] = useState("");

  const [
    restaurantAddress,
    setRestaurantAddress
  ] = useState("");

  const [
    loading,
    setLoading
  ] = useState(true);

  /*
  FETCH RESTAURANT
  */

  useEffect(() => {

    const fetchRestaurant =
      async () => {

      try {

        const res =
          await axios.get(
            `${BASE_API}/restaurants/${id}`
          );

        setRestaurantName(
          res.data.restaurantName
        );

        setRestaurantAddress(
          res.data.restaurantAddress
        );

      } catch (error) {

        alert(
          "Failed to load restaurant"
        );

      } finally {

        setLoading(false);

      }

    };

    fetchRestaurant();

  }, [id]);

  /*
  UPDATE
  */

  const updateRestaurant =
    async () => {

    try {

      await axios.put(
        `${BASE_API}/restaurants/${id}`,
        {
          restaurantName,
          restaurantAddress
        }
      );

      alert(
        "Restaurant updated successfully"
      );

    } catch (error) {

      alert(
        "Update failed"
      );

    }

  };

  if (loading)
    return <p>Loading...</p>;

  return (

    <div style={{ padding: 30 }}>

      <h2>
        Edit Restaurant
      </h2>

      <br />

      <input
        value={restaurantName}
        onChange={(e) =>
          setRestaurantName(
            e.target.value
          )
        }
        placeholder="Restaurant Name"
        style={styles.input}
      />

      <input
        value={restaurantAddress}
        onChange={(e) =>
          setRestaurantAddress(
            e.target.value
          )
        }
        placeholder="Address"
        style={styles.input}
      />

      <button
        onClick={
          updateRestaurant
        }
        style={styles.button}
      >
        Update Restaurant
      </button>

    </div>

  );

}

const styles = {

  input: {
    display: "block",
    padding: "12px",
    marginBottom: "15px",
    width: "300px"
  },

  button: {
    padding: "12px",
    background: "green",
    color: "#fff",
    border: "none",
    cursor: "pointer"
  }

};